<a class="list-group-item clearfix" style="cursor: pointer;" (click)="setOrder()">
    <h4 class="list-group-item-heading">{{order.PackageName}}</h4>
    <div class="row">
        <div class="col-sm-4">{{order.OrderDate | date:'M/dd/yyyy'}}</div>
        <div class="col-sm-4 payment-text-{{orderService.isPaid(order.PaidFlg)}}">${{order.PackageCost}} {{orderService.isPaid(order.PaidFlg)}}</div>
        <div class="col-sm-4">{{orderService.orderStatus(order.LastFieldId)}}</div>
    </div>
</a>
